<template>
    <div class="content-full-h" v-cloak>
        <div class="center-slider">
            <vue-glide :peek="{before: 50, after: 100}" :perView="slidesPerView" v-model="currentSlide" :rewind="false" :bound="true">
                  <vue-glide-slide v-for="(slide, index) in slides" :key="index" >
                      <div class="slide" @click="$router.push(slide.route)">
                          <div class="inner-slide">
                              <img :src="imagePath(slide.icon)">
                              <p>
                                  {{$t('customer_needs.box_' + (index + 1))}}
                              </p>
                          </div>
                      </div>
                  </vue-glide-slide>

                  <template slot="control">
                      <button class="prev-btn" data-glide-dir="<" v-show="currentSlide > 0">
                            <img :src="imagePath('backbutton')">
                      </button>
                      <button class="next-btn" data-glide-dir=">" v-show="currentSlide < (slides.length - slidesPerView)">
                            <img :src="imagePath('nextbutton')">
                      </button>
                  </template>
            </vue-glide>
        </div>
    </div>
</template>

<script>

import { Glide, GlideSlide } from 'vue-glide-js'
import MainNav from "@/components/MainNavigation.vue";
import 'vue-glide-js/dist/vue-glide.css'

export default {
    components: {
        'vue-glide': Glide,
        'vue-glide-slide': GlideSlide,
        'mainnav': MainNav,
    },

    data() {
        return {
            slides: [
                {
                    icon: 'Kachel_Letzte_Abfahrtskontrollen',
                    route: '/time-management',
                },
                {
                    icon: 'Kachel_Letzte_Abfahrtskontrollen', // 'Pflege-Digitale-Dienste-in-SAP-BSP-auswerten_V2_white',
                    route: '/time-management',
                },
                {
                    icon: 'Remote-Bus',
                    route: '/driving-style',
                },
                {
                    icon: 'Meine-Flotte---Ueberlandverkehr',
                    route: '/location-services',
                },
                {
                    icon: 'Pflege-Digitale-Dienste-in-SAP-BSP-auswerten_V2_white',
                    route: '/operational-planning',
                },
                {
                    icon: 'Telediagnosebewertungen-green',
                    route: '/operational-monitoring',
                },
            ],
            currentSlide: 0,
        }
    },

    computed: {
        slidesPerView: function() {
            let screenWidth = window.screen.width;
            
            if(screenWidth <= 1366) {
                return 3;
            }

            return 5;
        }
    },

    methods: {
        imagePath: function (fileName) {
            if(fileName != '')
                return require('../assets/icons/' + fileName + '.svg')
        },

        updateLocale: function() {
            this.$root.headline = this.$t('global.header_monitor');
            this.$root.subheadline = this.$t('global.fleet_management');
        }
    },

    mounted() {
        this.$root.headline = this.$t('global.header_monitor');
        this.$root.subheadline = this.$t('global.fleet_management');

        this.$root.$on('changedLocale', this.updateLocale);
    }
}
</script>

<style scoped>
.slide {
    width: 310px;
    height: 460px;
    background: #FDFDFD 0% 0% no-repeat padding-box;
    box-shadow: 25px 31px 53px #1516221A;
    border-radius: 6px;
    padding: 15px;
}

.center-slider {
    display: flex;
    flex-direction: row;
    align-items: center;
    height: 100%;
}

.inner-slide {
    width: 280px;
    height: 425px;
    display: flex;
    flex-direction: column;
    align-items: center;
    background: #FFFFFF 0% 0% no-repeat padding-box;
    box-shadow: 25px 31px 53px #1516220D;
    padding: 30px;
}

.inner-slide img {
    min-height: 125px;
    margin-bottom: 30px;
    height: 125px;
}

.inner-slide p {
    font-family: 'Light';
    font-size: 22px;
}

.glide__slide {
    margin-bottom: 100px;
    margin-top: 100px;
}

.prev-btn, .next-btn {
    position: absolute;
    top: calc(50% - 50px);
    background-color: transparent;
    border: none;
    cursor: pointer;
    outline: none;
}

.prev-btn {
    left: 0;
}

.next-btn {
    right: 0;
}

@media only screen and (max-device-width: 1366px) {
    .slide {
      width: 270px;
      height: 360px;
    }

    .inner-slide {
        width: 240px;
        height: 330px;
    }
    
    .inner-slide p {
        font-size: 17px;
    }

    .inner-slide img {
        min-height: 80px;
        height: 80px;
    }

    .prev-btn img, .next-btn img {
        width: 90px;
    }

    .content-full-h {
        height: calc(100vh - 163px);
    }
}
</style>